import { render, staticRenderFns } from "./CardStatsV2.vue?vue&type=template&id=4fc73f64&scoped=true&"
import script from "./CardStatsV2.vue?vue&type=script&lang=js&"
export * from "./CardStatsV2.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV2.vue?vue&type=style&index=0&id=4fc73f64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc73f64",
  null
  
)

export default component.exports